<div id="thumbnailView"
  class="d-flex align-items-center thumbnail-views bg-grey position-relative h-100"
  [ngClass]="getClass(backgroundCode, isCreationMode)"
  [ngStyle]="getBacKGroundStyle()">
  <div class="thumbnail-profile w-100" *ngIf="!isCreationMode && listing">
    <div class="pl-2 pt-2 pb-3">
      {{isMe == true ? youText : thumbnailInfo.fullName}}
    </div>
  </div>
  <img  *ngIf="((isCreationMode && !productImage && !backGroundImage) || showLoader)  && !listing" src="assets/themes/images/primary-loader.gif" width="40" height="40" class="loader-image">
  <div class="p-2 d-flex flex-column align-items-stretch w-100 h-100" [ngClass]="{'story-content': !isCreationMode && typingText?.length > 0,'story-content-without-tag': !isCreationMode && typingText?.length > 0 && tagUsers?.length === 0, 'justify-content-center': isCreationMode || ( !isCreationMode && typingText?.length === 0) || (this.storyType === this.STORY_TYPE.TEMPLATE || this.storyType === this.STORY_TYPE.PHARMA || this.storyType === this.STORY_TYPE.PHARMAREPOST), 'bottom-gap': !isCreationMode && isMe == true && viewCount === 0, 'bottom-gap-view': !isCreationMode && isMe == true && viewCount > 0 }">
    <div *ngIf="showLoader === false">
      <p *ngIf="typingText?.length > 0" class="fnt-size14px my-2 px-2 text-break text-center paragraph text-white">
        <span class="wrap-line" [ngClass]="{'story-text': !isCreationMode}">{{typingText}}</span>
      </p>
    </div>        
    <div *ngIf="storyType === STORY_TYPE.REPOST || storyType === STORY_TYPE.CERTIFICATE || storyType === STORY_TYPE.STORY " class="creation-share-img rounded mx-3 text-center"   
    [ngClass]="{
      'responsive-share-img mx-3': isCreationMode,
      'mx-auto': !isCreationMode,
      'image-with-tag': tagUsers?.length > 0 && !isCreationMode,
      'image-with-text-and-tag': typingText?.length > 10 && tagUsers?.length > 0 && !isCreationMode && isMe === false ,
      'image-with-text': typingText?.length > 20 &&  tagUsers?.length === 0 && !isCreationMode,
      'image-without-tag': tagUsers?.length === 0 && !isCreationMode
    }">
      <img *ngIf="productImage"  [src]="getProductImage()"
       (click)="$event.preventDefault();$event.stopPropagation();thumbnailInfo?.deeplink ? generateProductMeta(true):null;">
       <app-meta-generator *ngIf="productMeta" [viewPostText]="viewPostText" [isMetaState]="true"   [isTagMetaGenerated]="false" [deepLink]="thumbnailInfo?.deeplink"
       (clickedOutSide)="restoreView()" (emitOnMeta)="onMeta($event)">
     </app-meta-generator>
      </div>
      <div  class="text-center my-1" *ngIf="tagUsers && tagUsers.length  > 0 &&  showLoader === false">
        <div  [ngClass]="{
          'story-with-tag': !isCreationMode,
          'pharma-repost' : isPharmaRepost
        }">
          <div class="mobile-view" *ngIf="!isCreationMode"> 
            <p *ngFor="let tagUser of tagUsers" class="mb-1" (click)="$event.preventDefault();$event.stopPropagation();generateTagMeta()">
              <span class="tag-chip text-break cursor-pointer primary-small text-white fnt-size10px position-relative" (click)="$event.preventDefault();$event.stopPropagation();generateTagMeta(tagUser)">
                @{{tagUser.fullName}}
                <app-meta-generator *ngIf="currentTag=== tagUser" [isMetaState]="isTagMeta"   [isTagMetaGenerated]="true" [seeMore]="currentTag"
                 (clickedOutSide)="restoreView()" (emitOnMeta)="onMeta($event)">
              </app-meta-generator>
              </span>
            </p>
          </div>
          <div class="web-view px-4">
            <div *ngIf="!isCreationMode">
              <span *ngFor="let tagUser of tagUsers" (click)="$event.preventDefault();$event.stopPropagation();generateTagMeta(tagUser)">
                <span class="tag-chip cursor-pointer text-break primary-small mr-1 mt-1 text-white fnt-size10px position-relative">
                  @{{tagUser.fullName}} 
                  <app-meta-generator *ngIf="currentTag=== tagUser" [isMetaState]="isTagMeta"  [isTagMetaGenerated]="true" [seeMore]="currentTag"
                  (clickedOutSide)="restoreView()" (emitOnMeta)="onMeta($event)"></app-meta-generator>
                </span>
              </span>
            </div>
            <div *ngIf="isCreationMode" class="d-flex flex-wrap justify-content-center" >
              <span  *ngFor="let tagUser of tagUsers">
                <span class="tag-chip text-break primary-small text-white mr-1  mt-1 fnt-size10px position-relative">
                  @{{tagUser.fullName}}
                  <img class="cursor-pointer cross-tag" *ngIf="isTagFeatureInUse" (click)="$event.preventDefault();$event.stopPropagation();removeTag(tagUser)" src="assets/images/cross.svg" alt="cross">
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div *ngIf="listing" [ngClass]="{
      'thumbnail-icon-for-powered': thumbnailInfo.type === 'PHARMA',
      'thumbnail-icon-for-user': thumbnailInfo.type === 'USER' || thumbnailInfo.type === 'ME'}">
    <app-profile-highlighter
      [boxSize]="thumbnailInfo.type === 'PHARMA' ? highlighterSize.MEDIUM : highlighterSize.SMALL"
      [backgroundImg]="thumbnailInfo?.fileCode" [activeStatus]="activeStatus">
    </app-profile-highlighter>
  </div>
</div>

<ng-template #noThumbnailInfo>
  <div class="w-100">
    <app-no-info-available [noInfoSrc]="noInfoSrc" [noInfoType]="NO_INFO_TYPE.SINGLE_THUMBNAIL"
    [noInfoHeading]="mls.languageText.no_stories.key3" [noInfoParagraph]="mls.languageText.no_stories.key4">
  </app-no-info-available>
  </div>
</ng-template>
